import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "split",
  "use": "split-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"split\"><path d=\"m14 20 2.29-2.29-2.88-2.88 1.42-1.42 2.88 2.88L20 14v6zm-4 0H4v-6l2.29 2.29 4.71-4.7V4h2v8.41l-5.29 5.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol